<app-breadcrumb [title]="'Gestión de Departamentos'" [items]="['Extractos']"
  [active_item]="'Gestión de Departamentos'"></app-breadcrumb>
<div class="card">
  <div class="card-header bg-primary">
    <h5 class="text-uppercase text-white"><strong>Listado de departamentos activos</strong></h5>
  </div>

  <div class="card-body custom-datatable noscroll">
    <div class="row mb-12">
      <div class="col-3 ms-auto">
        <div class="input-group">
          <input type="text" class="form-control" placeholder="Buscar....." [(ngModel)]="searchText"
            (input)="filterData()" />
          <span class="input-group-text">
            <i class="fa fa-search"></i> <!-- Icono de búsqueda -->
          </span>
          
        </div>
      </div>
    </div>


    <div class="custom-datatable table-responsive my-4">
      <table class="table table-hover table-bordered" id="tblDepartamentos">
        <thead class="bg-primary">
          <tr>
            <th class="text-center"><strong>DEPARTAMENTO</strong></th>
            <th class="text-center"><strong>MUNICIPIO</strong></th>
            <th class="text-center"><strong>ACCIONES</strong></th>
          </tr>
        </thead>

        <tbody>
          <tr
            *ngFor="let municipios of municipiosRutas of filteredTableItems | paginate: { itemsPerPage: pageSize1, currentPage: page1 }">
            <td class="text-center">{{ municipios.departamento?.nombre }}</td>
            <td class="text-center">{{ municipios.MUNICIPIO }}</td>
            <!-- Buscar tarjeta correspondiente -->
            <td>
              <div class="action text-center">
                <ul class="list-inline d-flex justify-content-center gap-3">
                  <li class="list-inline-item edit">
                    <a href="javascript:void(0)">
                      <i class="icon-pencil-alt" (click)="openModalMunicipio(myModal3, municipios.IDMUN)" ngbTooltip="Editar"></i>
                    </a>
                  </li>
                  <li class="list-inline-item delete">
                    <a href="javascript:void(0)">
                      <i class="icon-trash" (click)="avisoInactivarMunicipio(municipios.IDMUN)" ngbTooltip="Inactivar"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </td>
          </tr>
        </tbody>
      </table>


    </div>
    <div class="d-flex justify-content-between align-items-center mt-4">
      <!-- Selector de registros por página alineado a la izquierda -->
      <div class="d-flex align-items-center">
        <label for="pageSize1" class="me-2">Mostrar:</label>
        <select id="pageSize1" class="form-select w-auto" [(ngModel)]="pageSize1" (change)="page1 = 1">
          <option *ngFor="let size1 of [5, 10, 20, 50, 100]" [value]="size1">{{ size1 }}</option>
        </select>
        <span class="ms-2">registros por página</span>
      </div>

      <div class="mx-auto text-center">
        <span class="badge bg-primary ms-1"><b><span>Total registros: </span>{{ municipiosRutas.length || 0
            }}</b></span>
      </div>

      <!-- Paginador alineado a la derecha -->
      <div class="text-end paginador-personalizado">
        <pagination-controls (pageChange)="page1 = $event" [maxSize]="5" [directionLinks]="true" [autoHide]="true"
          previousLabel="Anterior" nextLabel="Siguiente">
        </pagination-controls>
      </div>
    </div>
    <div class="card-body">
      <div class="btn-showcase text-center">
        <button class="btn btn-outline-success-2x" type="button" placement="top" ngbTooltip="Exportar a Excel"
          (click)="exportarExcel('tblDepartamentos', 'Listado_Departamentos_Activos')">
          <i class="icofont icofont-file-excel"></i> EXCEL
        </button>

        <button class="btn btn-outline-danger-2x" type="button" placement="top" ngbTooltip="Exportar a PDF" (click)="
            exportToPDF(
              'tblDepartamentos',
              'Listado_Departamentos_Activos',
              'Listado de Departamentos Activos'
            )
          ">
          <i class="icofont icofont-file-pdf"></i> PDF
        </button>
        <button class="btn btn-outline-primary-2x" type="button" placement="top" ngbTooltip="Crear"
          (click)="openModalMunicipio(myModal3)">
          <i class="icofont icofont-plus"></i> Crear
        </button>
      </div>
    </div>
  </div>
</div>

<ng-template #myModal3 let-modal>
  <div class="card border-4 rounded-3">
    <div class="card-header bg-primary text-white d-flex justify-content-between align-items-center rounded-top">
      <h5 class="mb-0">
        {{ editMode ? 'EDITAR RUTA - ID: ' + formMUNICIPIOS.get('IDMUN')?.value : 'CREACIÓN DE ORIGEN / DESTINO' }}
      </h5>
    </div>
    <div class="card-body">
      <form [formGroup]="formMUNICIPIOS">
        <div class="row g-3">

                  <div class="col-md-3">
                    <label class="form-label"><strong>Departamento *</strong>:</label>
                    <ng-select [items]="departamentos" bindLabel="nombre" bindValue="id_departamento"
                      placeholder="Selecciona una opción" formControlName="IDEP">
                    </ng-select>
                  </div>

          <div class="col-md-3 mb-3">
            <label class="form-label"><strong>Origen / Destino</strong>:</label>
            <input class="form-control" type="text" placeholder="Ingrese descripción" formControlName="MUNICIPIO" />
          </div>
        </div>

        <div class="modal-footer">
          <button class="btn btn-primary" (click)="guardarMunicipio()">
            {{ editMode ? "Actualizar" : "Guardar" }}
          </button>
          <button class="btn btn-secondary" (click)="modal.dismiss()">
            Cancelar
          </button>
        </div>
      </form>
    </div>
  </div>
</ng-template>